export const PAGE_PATH = {
  USER_VIDEO_DETAIL_PAGE: '/user/video/detail', // ?user_id
  USER_VIDEO_EDIT_PAGE: '/user/video/edit', // ?user_id
  USER_VIDEO_ADD_PAGE: '/user/video/add', // user_id
  USER_PAGE: '/user',
  LOGIN_PAGE: '/login',
  TOP_PAGE: '/',
} as const;
